import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, ArrowLeft, MailCheck } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { AuthLayout, Field } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui-bits";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err, t("auth.forgot.error")));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout title={t("auth.forgot.sentTitle")} subtitle={t("auth.forgot.sentSubtitle", { email })}>
        <div data-testid="forgot-sent" className="rounded-lg border border-primary/20 bg-primary/5 p-4 flex items-start gap-3">
          <MailCheck size={18} className="text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground leading-relaxed">{t("auth.forgot.sentBody")}</p>
        </div>
        <Link to="/login" data-testid="back-to-login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline">
          <ArrowLeft size={15} /> {t("auth.forgot.backToLogin")}
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t("auth.forgot.title")} subtitle={t("auth.forgot.subtitle")}>
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <Field label={t("auth.workEmail")}>
          <Input data-testid="forgot-email" type="email" required autoComplete="email" placeholder="you@company.com"
            value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-lg" />
        </Field>
        <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-11 rounded-lg active:scale-[0.98] transition-transform">
          {loading ? <Spinner /> : <>{t("auth.forgot.cta")} <ArrowRight size={16} className="ml-1" /></>}
        </Button>
      </form>
      <Link to="/login" data-testid="back-to-login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline">
        <ArrowLeft size={15} /> {t("auth.forgot.backToLogin")}
      </Link>
    </AuthLayout>
  );
}
